(function FAQ(SectionsDesign) {
  'use strict';
  
  if (SectionsDesign.faq) return;
  SectionsDesign.faq = {};

  var support = getSupport();

var init = function() {
    // Suche nach allen Datenkonfigurationen
    var configNodes = Array.from(document.querySelectorAll('[data-faq-config]'));
    
    configNodes.forEach(configNode => {
        var section = compose(publicAPI, setEvents, getBlocks, getConfig)(configNode);
        SectionsDesign.faq[section.id] = section;
        
        // Überprüfe alle Blöcke
        if (section.config && section.config.blockIds) {
            section.config.blockIds.forEach(blockId => {
                const trigger = document.querySelector(`[data-faq-trigger="\${blockId}"]`);
                if (trigger && !trigger.hasAttribute('data-faq-init')) {
                    trigger.setAttribute('data-faq-init', true);
                    trigger.addEventListener('click', function() {
                        if (section.blocks && section.blocks[blockId]) {
                            toggle(section.blocks[blockId]);
                        }
                    });
                }
            });
        }
    });
}

  init();

    // NEU: Event Listener für Shopify Editor
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(event) {
      init();
    });
  }

  // Öffentlich zugängliche API
  function publicAPI(config) {
    return {
      id: config.sectionId,
      config: config,
      blocks: zipObj(config.blockIds, config.blocks),
      init: init
    };
  }

  //**************************

  // Events für FAQ-Block
  function blockEvents(block) {
    if (block.trigger.hasAttribute('data-faq-init')) return block;
    
    block.trigger.setAttribute('data-faq-init', true);
    block.trigger.addEventListener('click', function () {
      toggle(block);
    });

    return block;
  }

  // Umschalten des Zustands (ausklappen/einklappen)
  function toggle(block) {
    block.collapsed ? expand(block) : collapse(block);
    return block;
  }
  
  // Block ausklappen
  function expand(block) {
    block.button.setAttribute('aria-expanded', true);
    block.panel.removeAttribute('hidden');
    animate(block.panel, 'normal');
    return block;
  }
  
  // Block einklappen
  function collapse(block) {
    block.button.setAttribute('aria-expanded', false);
    block.panel.setAttribute('hidden', '');
    animate(block.panel, 'reverse');
    return block;
  }
  
  // Block-Zustand prüfen (eingeklappt oder nicht)
  function isCollapsed(block) {
    return block.button.getAttribute('aria-expanded') === 'false';
  }

  // Animation für das Panel
  function animate(element, direction) { 
    if (!support.WebAnimations) return;

    element.setAttribute('data-is-animating', true);

    element.animate([
      { height: 0 },
      { height: element.scrollHeight + 'px' }
    ], {
      duration: 240,
      fill: 'both',
      easing: 'cubic-bezier(0.4, 0.0, 0.2, 1)',
      direction: direction
    }).onfinish = function() {
      element.removeAttribute('data-is-animating');
      this.cancel();
    };
  }

  //**************************

  // Verbindung der Blocks mit der Konfiguration
  function getBlocks(config) {
    config.blocks = config.blockIds.map(block);
    return config;
  }

  // Erzeugung des Block-Objekts
  function block(blockId) {
    return {
      trigger: document.querySelector('[data-faq-trigger="' + blockId + '"]'),
      button: document.querySelector('[data-faq-button="' + blockId + '"]'),
      panel: document.querySelector('[data-faq-panel="' + blockId + '"]'),

      get collapsed() { return isCollapsed(this); },
      select: function select() { return expand(this); },
      deselect: function deselect() { return collapse(this); }
    };
  }

  // Hinzufügen von Events zu Blöcken
  function setEvents(config) {
    config.blocks.forEach(blockEvents);
    return config;
  }

  // Konfigurationsdaten auslesen
  function getConfig(node) {
    return JSON.parse(node.innerHTML);
  }

  // Feature Detection
  function getSupport() {
    return {
      WebAnimations: (typeof Element.prototype.animate === 'function')
    };
  }

  //**************************

  // Hilfsfunktion: Array zu Objekt zusammenfügen
  function zipObj(keys, values) {
    return keys.reduce((acc, key, idx) => {
      acc[key] = values[idx];
      return acc;
    }, {});
  }

  // Funktionskomposition
  function compose() {
    var funcs = Array.prototype.slice.call(arguments).reverse();
    return function() {
      return funcs.slice(1).reduce((res, fn) => fn(res), funcs[0].apply(undefined, arguments));
    };
  }

})(window.SectionsDesign = window.SectionsDesign || {});
